<template>
  <div id="bto-result-panel-loading" v-if="isLoadingPrice">
    価格計算中...
    <svg class="loading-icon" viewBox="0 0 24 24">
      <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
    </svg>
  </div>
  <div
    id="bto-result-panel"
    :class="isLoadingPrice ? 'opacity-0 pointer-events-none' : 'opacity-100'"
  >
    <h2>合計</h2>
    <div id="bto-result-panel-price">
      ￥{{ result.b_prices }} → <strong>￥{{ result.prices }}</strong
      >(税込)
    </div>
    <div id="bto-result-parts-list">
      <ul>
        <li v-for="(parts, key) in result.qty" :key="key">
          {{ parts.name }} [ {{ parts.qty }}個 ]
          <PartsPriceStatus :qty-label="parts.empty" />
        </li>
      </ul>
      {{}}
    </div>
    <div id="bto-result-cartin">
      <form :action="cart_in_target" method="post">
        <fieldset>
          <input
            id="bto-result-cartin-item-id"
            type="hidden"
            name="litBTOItem[ID]"
            :value="jewelleryItemId"
          />
          <input
            id="bto-result-cartin-item-code"
            type="hidden"
            name="litBTOItem[itemCode]"
            :value="jewelleryItemCode"
          />
          <input
            id="bto-result-cartin-size-id"
            type="hidden"
            name="litBTOItem[size]"
            :value="'edit_asid_' + $store.state.current_size_id"
          />
          <input
            id="bto-result-cartin-row-data"
            type="hidden"
            name="litBTOItem[row_data]"
            :value="$store.state.result.row_data"
          />
          <input
            id="bto-result-cartin-bto-item-id"
            type="hidden"
            name="add-to-cart"
            :value="btoItemId"
          />
          <input
            id="bto-result-cartin-remakecode"
            type="hidden"
            name="remake_code"
            :value="$store.state.result.remake_code"
          />
          <input type="hidden" name="litAction" value="cart_in" />

          <button
            v-if="true === $store.state.result.yoyaku"
            id="bto-cart-in-yoyaku"
            class="send"
            type="submit"
            value="入荷待ちの商品を予約する"
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M10,0V4H8L12,8L16,4H14V0M1,2V4H3L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42C7.29,15 7.17,14.89 7.17,14.75L7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.59 17.3,11.97L21.16,4.96L19.42,4H19.41L18.31,6L15.55,11H8.53L8.4,10.73L6.16,6L5.21,4L4.27,2M7,18A2,2 0 0,0 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20A2,2 0 0,0 7,18M17,18A2,2 0 0,0 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20A2,2 0 0,0 17,18Z"
              />
            </svg>
            &nbsp;入荷待ちの商品を予約する
          </button>

          <button
            v-else
            id="bto-cart-in"
            class="send"
            type="submit"
            value="カートに入れる"
          >
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M10,0V4H8L12,8L16,4H14V0M1,2V4H3L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42C7.29,15 7.17,14.89 7.17,14.75L7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.59 17.3,11.97L21.16,4.96L19.42,4H19.41L18.31,6L15.55,11H8.53L8.4,10.73L6.16,6L5.21,4L4.27,2M7,18A2,2 0 0,0 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20A2,2 0 0,0 7,18M17,18A2,2 0 0,0 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20A2,2 0 0,0 17,18Z"
              />
            </svg>
            &nbsp;カートに入れる
          </button>
        </fieldset>
      </form>
    </div>
    <div id="bto-result-remakecode">
      <strong>URL:</strong>
      <p>
        <span>{{ result.url }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PartsPriceStatus from "@/components/BtoPanel/PartsPriceStatus.vue";

export default {
  name: "PanelBtoResult",

  components: {
    PartsPriceStatus,
  },

  props: {
    btoItemId: {
      type: String,
    },
    jewelleryItemId: {
      type: String,
    },
    jewelleryItemCode: {
      type: String,
    },
  },

  computed: {
    bto_result() {
      return this.result;
    },

    cart_in_target() {
      return process.env.VUE_APP_LIT_CART_IN_TARGET;
    },
    ...mapState(["result", "isLoadingPrice"]),
  },
};
</script>

<style scoped lang="stylus">

#bto-cart-in
  border: 3px solid #fd6e82
  --tw-gradient-from: #fd6e82;
  --tw-gradient-stops: var(--tw-gradient-from), #fd6e82, var(--tw-gradient-to, rgba(253, 177, 189, 255));

#bto-cart-in-yoyaku
  border: 3px solid #ff914f
  --tw-gradient-from: #ff914f;
  --tw-gradient-stops: var(--tw-gradient-from), #ff914f, var(--tw-gradient-to, rgba(255, 213, 189, 157));

@css {
  #bto-result-panel {
    border-color: #efebe3;
    @apply text-left text-sm border border-solid p-4  transition transition-opacity duration-1000 ease-in-out
  }
  #bto-result-panel h2 {
    color: #694b37;
    @apply text-left font-bold text-base border-b border-solid
  }

  #bto-result-panel-price {
    @apply text-right px-0 py-4
  }
  #bto-result-panel-price strong {
    @apply text-xl text-red-500 text-right
  }

  #bto-result-parts-list {
    border-color: #efebe3;
    @apply border-double border-4 p-2
  }

  #bto-result-parts-list li {
    border-color: #efebe3;
    @apply border-dashed border-b mb-2
  }

  #bto-result-cartin {
    @apply text-center p-2 my-4
  }

  #bto-result-remakecode p {
    @apply w-11/12 text-xs select-all shadow-inner border border-solid border-gray-100 p-1 overflow-x-hidden whitespace-nowrap m-auto
  }

  #bto-cart-in,
  #bto-cart-in-yoyaku {
    @apply bg-gradient-to-t text-white text-lg font-bold p-2 w-3/4 rounded-lg
  }

  #bto-cart-in svg,
  #bto-cart-in-yoyaku svg {
    @apply inline fill-current text-white w-6 h-6 align-text-top
  }

  #bto-result-panel-loading {
    @apply text-center mx-auto my-2
  }
  #bto-result-panel-loading .loading-icon {
    @apply animate-spin h-4 w-4 m-auto
  }

}
</style>
